module.exports = __webpack_public_path__ + "static/media/product25.5873e73f.jpg";